import {
  Phone,
  Mail,
  Users,
  CheckSquare,
  TrendingUp,
  FileText,
  LucideIcon,
} from "lucide-react";
import {
  ActivityType,
  ReminderOption,
  TaskStatus,
  TaskType,
  TransportMode,
} from "../types/tasks";

export const TASK_STATUS_COLORS: Record<TaskStatus, string> = {
  new: "bg-gray-100 text-gray-700 border border-gray-200",
  in_progress: "bg-blue-50 text-blue-700 border border-blue-200",
  done: "bg-green-50 text-green-700 border border-green-200",
  overdue: "bg-red-50 text-red-700 border border-red-200",
};

export const TASK_TYPE_ICON: Record<TaskType, LucideIcon> = {
  todo: CheckSquare,
  sales: TrendingUp,
};

export const ACTIVITY_TYPE_ICON: Record<ActivityType, LucideIcon> = {
  call: Phone,
  email: Mail,
  meeting: Users,
  checklist: CheckSquare,
  note: FileText,
};

export const REMINDER_OPTIONS: ReminderOption[] = [
  "none",
  "15min",
  "1hr",
  "1day",
];

export const TRANSPORT_MODES: TransportMode[] = ["road", "sea", "air"];

export const INCOTERM_OPTIONS = [
  "EXW",
  "FCA",
  "FAS",
  "FOB",
  "CFR",
  "CIF",
  "CPT",
  "CIP",
  "DAP",
  "DPU",
  "DDP",
];

// Must match Shipment.cargoItems.type enum exactly
export const CARGO_UNIT_OPTIONS = [
  "EUR",
  "BOX",
  "PLT",
  "CTN",
  "BAG",
  "DRM",
  "CYL",
  "CRATE",
  "FTL",
  "LTL",
  "OTHER",
];

export const TASK_STATUSES: TaskStatus[] = [
  "new",
  "in_progress",
  "done",
  "overdue",
];

export const TASK_TYPES: TaskType[] = ["todo", "sales"];

export const ACTIVITY_TYPES: ActivityType[] = [
  "call",
  "email",
  "meeting",
  "checklist",
  "note",
];

export const MOCK_TMS_ENABLED = true;
